import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryNav() {
  const colorMap: Record<string, { bg: string; text: string; icon: string }> = {
    accent: {
      bg: 'bg-accent-50 hover:bg-accent-100',
      text: 'text-accent-700',
      icon: 'text-accent-500',
    },
    secondary: {
      bg: 'bg-secondary-50 hover:bg-secondary-100',
      text: 'text-secondary-700',
      icon: 'text-secondary-500',
    },
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            App分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按需选择，找到最适合你的体育App类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.accent;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} rounded-xl p-6 transition-all duration-200 cursor-pointer group`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 bg-background-50`}>
                  <i className={`${cat.icon} text-xl ${colors.icon}`}></i>
                </div>
                <h3 className={`font-semibold text-foreground-950 mb-2 text-base ${colors.text}`}>
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="flex items-center gap-1 mt-4 text-sm font-medium text-foreground-700 group-hover:translate-x-1 transition-transform duration-200">
                  <span className="whitespace-nowrap">浏览分类</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}